<ul>
    <li
        *ngFor="let unit of units"
        [class.is-selected]="unit === selectedUnit"
        (click)="onItemSelection(unit)"
    >
        {{ getLabel(unit) }}
    </li>
</ul>
